import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import initialState from './initialState'

export default {
  namespaced: true,
  state: initialState(),
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/global/index.js